import React from 'react';

export type TriptychPanel<T extends string> = {
  title: T;
  content: React.ReactNode;
};

export type TriptychProps = {
  panels: [
    TriptychPanel<'Truth'>,
    TriptychPanel<'Estimate'>,
    TriptychPanel<'Truth − Estimate'>,
  ];
};

/**
 * 3-column triptych layout used in the x57_3d_surface_triptych article.
 * Each panel renders with the shared dark-panel chrome; gap is 12px.
 * The caller fills `content` — typically with a HeatmapPanel or Surface3D,
 * using the diverging palette for the "Truth − Estimate" column.
 */
export const Triptych: React.FC<TriptychProps> = ({ panels }) => (
  <div className="as-triptych">
    {panels.map((panel) => (
      <div key={panel.title} className="as-triptych-panel">
        <div className="as-triptych-title">{panel.title}</div>
        <div className="as-triptych-body">{panel.content}</div>
      </div>
    ))}
  </div>
);
